import { ArrowRight } from './Icons';
import { useTranslation } from '../contexts/TranslationContext';
import { DarkSurface } from './DarkSurface';
import { DemoRequestCta } from './DemoRequestCta';
import { landingSectionClassName } from './landingSectionClassName';
import { BrandButton } from './ui/BrandButton';

interface LandingCallToActionProps {
  isVisible: boolean;
  onGetStarted: () => void;
  onStartIntent: () => void;
}

export function LandingCallToAction({
  isVisible,
  onGetStarted,
  onStartIntent,
}: LandingCallToActionProps) {
  const { t } = useTranslation();

  return (
    <section id="cta" className={landingSectionClassName({ className: 'px-4 py-14 sm:px-6 sm:py-32' })}>
      <div className="max-w-4xl mx-auto text-center">
        <div
          id="cta-content"
          data-landing-scroll-target
          data-animate
          className={`transition-all duration-1000 ${
            isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
          }`}
        >
          <DarkSurface className="theme-cta-surface rounded-3xl p-6 sm:p-12">
            <h2 className="theme-heading-primary mb-4 text-3xl font-bold sm:mb-6 sm:text-4xl md:text-6xl">
              {t('cta.title')}
            </h2>
            <p className="text-base sm:text-xl text-slate-300 mb-7 sm:mb-10 max-w-2xl mx-auto">
              {t('cta.subtitle')}
            </p>
            <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
              <BrandButton
                onClick={onGetStarted}
                onFocus={onStartIntent}
                onPointerEnter={onStartIntent}
                onPointerDown={onStartIntent}
                size="lg"
                className="group w-full sm:w-auto sm:px-10 sm:py-5 sm:text-xl"
              >
                {t('cta.button')}
                <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6 group-hover:translate-x-2 transition-transform" />
              </BrandButton>
              <DemoRequestCta analyticsSource="public_landing_final_demo_cta" />
            </div>
          </DarkSurface>
        </div>
      </div>
    </section>
  );
}
